<template>
    <v-container grid-list-md text-xs-center class="py-4 mx-auto px-2">
        <v-layout row wrap justify-start>
            <v-flex v-for="sistema in sistemasIntegrados" :key="sistema.nome" xs12 sm6 md4 lg4 class="pa-2">
                <v-card v-if="!loadingIntegracoes" class="card-sistema">
                    <v-card-text class="px-0">
                        <v-chip color="transparent" :style="sistema.possuiFilaRequisicoes ? 'height: 60px' : 'height: 61px'"
                                :class="sistema.possuiFilaRequisicoes ? 'mt-5 mb-4 mx-0' : 'my-5 mx-0'" disabled>
                            <span class="icone-sistema text--disabled">
                                <i :class="selecionarIcone(sistema)" style="font-size: 3em" aria-hidden="true"/>
                            </span>
                            <v-chip color="transparent" disabled>
                                <p style="font-size: 25px" class="text--secondary"> {{sistema.nome}}</p>
                                <span v-if="sistema.situacao === situacoesSistemasIntegrados.OK"
                                      class="mensagem-status online">
                                    <i class="fas fa-circle" aria-hidden="true"/>
                                    Online
                                </span>
                                <span v-else-if="sistema.situacao === situacoesSistemasIntegrados.ERRO"
                                      class="mensagem-status offline">
                                    <i class="fas fa-circle" aria-hidden="true"/>
                                    Offline
                                </span>
                            </v-chip>
                        </v-chip>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <span v-if="sistema.possuiFilaRequisicoes" class="right">
                            <v-tooltip id="rtooltip" top nudge-left="45">
                                <v-icon slot="activator" @click="exibirFilaRequisicoes(sistema)">
                                    format_list_bulleted
                                </v-icon>
                                Fila de requisições
                            </v-tooltip>
                        </span>
                    </v-card-actions>
                </v-card>
                <content-loader v-else height="200" class="elevation-2 card-loader"
                                primaryColor="#ededed" secondaryColor="#e0e0e0"/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>

import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {actionTypes, situacoesSistemasIntegrados} from '@/core/constants'
import { ContentLoader } from 'vue-content-loader'

export default{
    name: 'InformacoesSistemaDashboard',
    mixins: [SmartTimerMixin],
    components: {ContentLoader},
    data(){
        return{
            possuiRequisicoes: true,
            situacoesSistemasIntegrados,
            sistemasIntegrados: [{},{},{}],
            loadingIntegracoes: true
        }
    },
    methods:{
        async buscarDadosIntegracoes(){
            const dados = await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_INFORMACOES_SISTEMA)
            this.loadingIntegracoes = false
            this.sistemasIntegrados = dados.sistemasIntegrados
        },
        selecionarIcone(sistema){
            if(sistema.tipo === 'FORNECEDORES')
                return 'fas fa-users'
            if(sistema.tipo === 'GESTAO')
                return 'fas fa-gavel'
            if(sistema.tipo === 'VIRTUALIZACAO')
                return 'fas fa-file'
            if(sistema.tipo === 'PAGAMENTOS')
                return 'fas fa-money-check-alt'
            if(sistema.tipo === 'CONTRATACOES_PUBLICAS')
                return 'fas fa-file-invoice-dollar'

            return 'fas fa-cog'
        },
        exibirFilaRequisicoes(sistema){
            this.$router.push({name: 'FilaRequisicoes', params: {sistema: sistema.nome}})
        }
    },
    mounted(){
        this.buscarDadosIntegracoes()
        
        this.createSmartTimer('buscarDadosIntegracoes', 'buscarDadosIntegracoes', 30000, {
            autostart: true,
            immediate: true
        })
    }

}
</script>
<style>
.mensagem-status{
    font-size: 1.1em;
    color: grey;
    position: absolute;
    float: none;
    padding-left: 2px;
    padding-top: 30px;
}

.mensagem-status.online{
    color: green;
}

.mensagem-status.offline{
    color: red;
}

</style>

<style scoped>
.v-tooltip__content:before {
    content:"";
    position: absolute;
    left: 80%;
    top: 99%;
    width: 0;
    height: 0;

    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid slategrey;
}
</style>
